import type { AxiosResponse } from 'axios';
import type { ThunkAction } from 'redux-thunk';

import store from 'store';
import ApiClient, { createTokenConfig, isCancelled } from 'api/ApiClient';
import { NotificationsAction, showError } from '@spike/notifications-action';

import type { ServicesInsightsReportDto } from './ServicesInsightsReportDto';
import { convertToServicesInsightsReport } from './servicesInsightsReportConverter';
import type { ServicesInsightsReport } from 'model/ServicesInsightsReport';

import {
    SERVICES_INSIGHTS_REPORT_GET_ERROR,
    SERVICES_INSIGHTS_REPORT_GET_START,
    SERVICES_INSIGHTS_REPORT_GET_SUCCESS,
    ServicesInsightsReportAction
} from './ServicesInsightsReportActionsTypes';

export const getServicesInsightsReport = (
    start?: string,
    end?: string,
    page = 1,
    perPage = 10
): ThunkAction<void, null, null, ServicesInsightsReportAction | NotificationsAction> => {
    return async dispatch => {
        dispatch(getStart());

        const { marketplaceId, token } = store.getState().login.auth;

        let url = `/services_insights_report?marketplace_id=${marketplaceId}`;
        if (start) url += `&start=${start}`;
        if (end) url += `&end=${end}`;
        url += `&page=${page}`;
        url += `&per_page=${perPage}`;

        try {
            const response: AxiosResponse<ServicesInsightsReportDto> = await ApiClient.get(
                url,
                createTokenConfig(token!)
            );

            dispatch(getSuccess(convertToServicesInsightsReport(response.data)));
        } catch (apiError) {
            if (!isCancelled(apiError)) {
                dispatch(getError());
                dispatch(showError('Too many records to display. Please try a shorter date range.'));
            }
        }
    };
};

const getStart = (): ServicesInsightsReportAction => ({
    type: SERVICES_INSIGHTS_REPORT_GET_START
});

const getSuccess = (report: ServicesInsightsReport): ServicesInsightsReportAction => ({
    type: SERVICES_INSIGHTS_REPORT_GET_SUCCESS,
    payload: { report }
});

const getError = (): ServicesInsightsReportAction => ({
    type: SERVICES_INSIGHTS_REPORT_GET_ERROR
});
